export default __webpack_public_path__ + "static/media/reports.9a759de6.svg";